import * as React from 'react';
import * as courseDuration from '../styles/courseDuration.module.scss';

export const CourseDuration = () => {
  return (
    <section className={courseDuration.courseDuration}>
      <div className={'container'}>
        <div className={courseDuration.courseDuration__wrapper}>
          <div className={courseDuration.courseDuration__info}>
            <p className={`${courseDuration.courseDuration__text} ${courseDuration.courseDuration__textBig}`}>
              Продолжительность курса
            </p>
            <h2 className={courseDuration.courseDuration__title}>
              <div className={courseDuration.courseDuration__selection}>14 видеоуроков</div>
            </h2>
            <p className={`${courseDuration.courseDuration__text} ${courseDuration.courseDuration__textMiddle}`}>
              с интерактивными упражнениями на отработку лексики
              <br />+ контрольные тесты
            </p>
            <div>
              <p className={`${courseDuration.courseDuration__text} ${courseDuration.courseDuration__textSmall}`}>
                Среднее время прохождения курса: 14 часов
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
